module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AjygWR/tc-custom/9781467440462.jpg?1742010799534",
      "alt": "This image is the cover for the book Hauerwas, Interventions (INT)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hauerwas, Interventions (INT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Stanley Hauerwas is one of the most important and robustly creative theologians of our time, and his work is well known and much admired. But Nicholas Healy -- himself an admirer of Hauerwas’s thought -- believes that it has not yet been subjected to the kind of sustained critical analysis that is warranted by such a significant and influential Christian thinker. As someone interested in the broader systematic-theological implications of Hauerwas’s work, Healy fills that gap in "), _c('i', [_vm._v("Hauerwas: A (Very) Critical Introduction")]), _vm._v("."), _c('br'), _c('br'), _vm._v("After a general introduction to Hauerwas’s work, Healy examines three main areas of his thought: his method, his social theory, and his theology. According to Healy, Hauerwas’s overriding concern for ethics and church-based apologetics so dominates his thinking that he systematically distorts Christian doctrine. Healy illustrates what he sees as the deficiencies of Hauerwas’s theology and argues that it needs substantial revision.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicholas M. Healy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nicholas M. Healy is professor of theology and religious studies at St. John's University, Jamaica, New York. His other books are Church, World and the Christian Life: Practical-Prophetic Ecclesiology and Thomas Aquinas: Theologian of the Christian Life.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0